import actions from './actions'
import mutations from './mutations'

const systemLogs = {
    namespaced: true,
    state: {
        types: [],
        systemLogs: [],
        isLoaded: false,
        pagination: {
            length: null,
            page: 1,
            total: null
        },
        filters: {
            fromDate: new Date(+new Date() - 604800000).toISOString().split('T')[0], // current date minus week
            toDate: new Date().toISOString().split('T')[0],
            email: null,
            types: []
        }
    },
    mutations,
    actions
}

export default systemLogs
